// Centralized configuration for review platforms.
// Replace the placeholder URLs with your live review links.

const reviews = {
  // Primary review destination used in header/home quick links.
  primary: {
    name: 'Google',
    url: 'https://g.page/r/CTKXgzvVaL3fEAE/review',
  },
  platforms: [
    {
      key: 'google',
      name: 'Google',
      url: 'https://g.page/r/CTKXgzvVaL3fEAE/review',
      icon: '⭐',
    },
  ],
};

export default reviews;
